import {
  ALL,
  UNIT_TYPES,
  DATE_TIME_FORMAT_SHORT,
  TABLE_NAMES,
  CHARTS_TYPES,
  BI_TOURS_VIEW_TYPES,
  BI_TOURS_BY_SITE_VIEW_TYPES,
  BI_TOURS_UNIT_TYPE,
  SHIFTS_UNIT_TYPE,
  PDF_REPORTS_VIEW_TYPE,
  ENTITY_STATUS,
  BI_NOTEBOOK_NOTES_VIEW_TYPES,
} from 'app/types/constants';
import { TIME } from 'app/types/tableFields';
import moment from 'moment';
import { IncidentReportsPageTabs } from './types';

export default Object.freeze({
  filterOpened: false,
  sort: {
    column: TIME,
    isDesc: true,
  },
  activityLogFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    clientID: undefined,
    siteID: undefined,
    userID: undefined,
    supervisorID: undefined,
    eventTypes: [],
    search: '',
  },
  infoBoardFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    sites: '',
    employees: '',
    infoCategory: '',
    search: '',
    supervisorID: undefined,
    statuses: [ALL],
  },
  irFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    siteID: undefined,
    userID: undefined,
    search: undefined,
    supervisorID: undefined,
    categoryIDs: [],
    statuses: [ALL],
    monthYear: {
      month: moment().subtract(1, 'month').month() + 1,
      year: moment().subtract(1, 'month').year(),
    },
    viewType: IncidentReportsPageTabs.TABLE,
  },
  monitoringFilters: {
    sites: '',
    employees: '',
    clientID: undefined,
    unitType: 'all', // mobile | guard | all
    eventTypes: [],
    search: '',
  },
  workHistoryFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    clientID: undefined,
    siteID: undefined,
    userID: undefined,
    supervisorID: undefined,
    unitType: SHIFTS_UNIT_TYPE.ALL,
    search: '',
    statuses: [ALL],
  },
  timesheetsFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    unitType: 'all', // mobile | guard | all
    search: '',
  },
  activityMapFilters: {
    search: '',
    city: '',
    province: '',
    unitType: 'all', // mobile | guard | all
  },
  clientDashboardFilters: {
    sites: '',
  },
  adminClientFilters: {
    cities: '',
    state: '',
    statuses: [ENTITY_STATUS.ACTIVE],
    search: '',
  },
  adminEmployeeFilters: {
    siteID: undefined,
    onDutyStates: [],
    position: [],
    statuses: [ENTITY_STATUS.ACTIVE],
    roleCodes: [],
    search: '',
    city: undefined,
  },
  adminContactFilters: {
    clientID: '',
    siteID: '',
    statuses: [ENTITY_STATUS.ACTIVE],
    search: '',
  },
  adminMobileUnitsFilters: {
    statuses: [ENTITY_STATUS.ACTIVE],
    mpCities: [],
    mpStates: [],

    search: '',
  },
  adminSiteFilters: {
    statuses: [ENTITY_STATUS.ACTIVE],
    client: '',
    site: '',
    city: '',
    state: '',
    search: '',
    supervisorID: undefined,
  },
  adminTasksFilters: {
    siteID: undefined,
    supervisorID: undefined,
    statuses: [ALL],
    search: '',
  },
  adminToursFilters: {
    siteID: undefined,
    supervisorID: undefined,
    statuses: [ALL],
    search: '',
  },
  visitorsFilters: {
    siteID: undefined,
    statuses: [ALL],
    search: '',
  },
  performanceFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    eventType: 'scan',
    unitType: UNIT_TYPES.SITES,
  },
  formResultsFilters: {
    formID: undefined,
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    search: '',
    formFieldID: undefined,
    userID: undefined,
    supervisorID: undefined,
    clientID: undefined,
    siteID: undefined,
    statuses: [ALL],
  },
  systemLogFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    tableName: ALL,
    siteID: undefined,
    userID: undefined,
  },
  visitorLogFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    siteID: undefined,
    visitorID: undefined,
    search: '',
    fieldType: undefined,
    statuses: [ALL],
  },
  formsFilters: {
    formID: undefined,
    search: '',
    statuses: [ALL],
  },
  biFilters: {
    events: {
      date: 'this_month',
      eventType: 'end',
      siteID: undefined,
    },
    entities: {
      date: 'this_month',
      entityName: 'sites',
    },
    viewType: CHARTS_TYPES.EVENT,
  },
  biToursFilters: {
    viewType: BI_TOURS_VIEW_TYPES.MONTHLY,
    viewTypeBySite: BI_TOURS_BY_SITE_VIEW_TYPES.BY_TOUR,
    tourID: undefined,
    employeeID: undefined,
    monthYear: {
      month: moment().month() + 1,
      year: moment().year(),
    },
    showOnlyScheduled: false,
    siteID: undefined,
    supervisorID: undefined,
    mobilePatrolID: undefined,
    clientID: undefined,
    unitType: BI_TOURS_UNIT_TYPE.ALL,
  },
  branchesFilters: {
    search: '',
    statuses: [ALL],
  },
  administratorsFilters: {
    search: '',
    statuses: [ENTITY_STATUS.ACTIVE],
    roleCodes: [],
    positionIDs: [],
    city: undefined,
  },
  pdfReportsFilters: {
    viewType: PDF_REPORTS_VIEW_TYPE.ALL,
  },
  entityPDFReportsFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    siteID: undefined,
    clientID: undefined,
    mobilePatrolID: undefined,
    userID: undefined,
    formID: undefined,
    tourID: undefined,
  },
  biIncidentReportsFilters: {
    siteID: undefined,
    userID: undefined,
    search: undefined,
    supervisorID: undefined,
    categoryIDs: [],
    statuses: [ALL],
    monthYear: {
      month: moment().month() + 1,
      year: moment().year(),
    },
    viewType: IncidentReportsPageTabs.MONTHLY,
  },
  notebookNotesFilters: {
    startDate: moment().startOf('month').format(DATE_TIME_FORMAT_SHORT),
    endDate: moment().endOf('day').format(DATE_TIME_FORMAT_SHORT),
    siteID: undefined,
    userID: undefined,
    search: '',
    supervisorID: undefined,
    tagIDs: [],
  },
  biNotebookNotesFilters: {
    siteID: undefined,
    userID: undefined,
    search: undefined,
    supervisorID: undefined,
    tagIDs: [],
    monthYear: {
      month: moment().month() + 1,
      year: moment().year(),
    },
    viewType: BI_NOTEBOOK_NOTES_VIEW_TYPES.MONTHLY,
  },

  selectedTab: TABLE_NAMES.EMPLOYEES,

  // Fields for activity map
  filterSelected: null,
  //
});
